module.exports = __webpack_public_path__ + "img/font1.c868bf8a.png";